import React, { useState, useEffect } from 'react';
import BasePage from '../components/BasePage';
import PanelDevis from '../components/Panels/PanelDevis';
import Subtitle from '../components/Subtitle';
import DocumentButton from '../components/Buttons/DocumentButton';

const Factures = (props) => {

    // Condition pour vérifier le nom de la facture portée
    const formatFactureName = (name) => {
        const pattern = /facture[\s_\-]*port[éeé]/i;

        // Si le nom de la facture correspond à l'expression régulière, retourne "échéancier"
        if (pattern.test(name)) {
            return "Échéancier";
        }

        return name;
    };

    const content = (data) => {
        console.log(data);
        return (
            <div id="factures-devis">
                <div className="grid grid-cols-1 lg:grid-cols-2">
                    <div id="factures" className="p-4">
                        <Subtitle icon="fa-solid fa-file-invoice">Mes factures</Subtitle>

                        {data && data.factures && (
                            <div className="divide-y divide-mgray">
                                {data.factures.map((f, index) =>
                                    <div className="relative py-6 px-2 flex gap-4 flex-wrap justify-between items-center">
                                        <div className="font-bold text-mdark">{formatFactureName(f.name)}</div>
                                            <DocumentButton
                                                filename={f.url}
                                                file_type="url"
                                                buttonTitle="Voir le document"
                                                className={`bg-cyan-500 hover:bg-cyan-600 font-bold py-1 px-3 rounded-3xl text-xs sm:text-sm`}
                                                icon="fa-file-pdf"
                                                loader={{ size: '80%', firstColor: 'white', secondColor: '#eeeeee88' }}
                                            />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    <div id="devis" className="p-2 sm:p-4">
                        <Subtitle icon="fa-solid fa-file-invoice-dollar">Mes devis</Subtitle>
                        {data && data.devis && (
                            <div className="divide-y divide-mgray">
                                {data.devis.map((d, index) =>
                                    <PanelDevis devis={d} />
                                )}
                            </div>
                        )
                        }
                    </div>
                </div>
            </div>
        );
    }

    return <BasePage content={content} title={props.title ?? null} />;
}

export default Factures;